import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocChangesRoute: InvariantJiraRoute = {
	name: 'eoc-changes',
	path: '/jira/ops/changes',
	exact: true,
};
